@if (client) {
  <ng-container [formGroup]="form">
    <div class="pinned">
      <div class="title">
        @if (!editing) {
          <bst-photo-well [color]="myclient ? 'var(--teamer-accent)' : '#f7f9fc'" shape="semi-round" [file]="client.logo"></bst-photo-well>
        }
        @if (editing && client.id) {
          <bst-photo-uploader [color]="myclient ? 'var(--teamer-accent)' : '#f7f9fc'" [value]="client.logo" [ratio]="myclient ? null : 1" [path]="'/clients/image'" [data]="{id: client.id}" shape="semi-round"></bst-photo-uploader>
        }
        @if (!editing) {
          <h1>{{ client.name }}</h1>
        }
        @if (editing) {
          <h1 class="input-full-width">
            <input fieldSize="giant" nbInput fullWidth [placeholder]="(client.is_tenant_root ? 'enterprojectcompany' : 'enterclientname') | translate" maxlength="100" class="input-full-width" formControlName="name">
          </h1>
        }
      </div>
      @if (couldEditMyself && !isOnCvsRoute && !isOnCompanySettingsTab) {
        <div class="buttons">
          @if (isProspect && !editing) {
            <button nbButton type="button" shape="semi-round" size="small" status="success" (click)="promote()">{{ 'promotetoclient' | translate }}</button>
          }
          @if (client.status === ClientStatus.ACTIVE && !editing && couldArchive && !client.is_tenant_root) {
            <button nbButton type="button" shape="semi-round" size="small" status="basic" (click)="setStatus(ClientStatus.ARCHIVED)">{{ 'archiveclient' | translate }}</button>
          }
          @if (client.id && editing) {
            <button nbButton size="small" status="basic" (click)="editing = false" shape="semi-round">{{'cancel' | translate}}</button>
          }
          @if (editing) {
            <button [bstErroring]="form" (bstErroringSuccess)="saveClient()" nbButton size="small" status="primary" shape="semi-round">{{(me.client.id !== client.id ? 'saveclient' : 'save') | translate}}</button>
          }
          @if (!editing && client.status === ClientStatus.ACTIVE && couldEdit) {
            <button nbButton size="small" status="primary" (click)="editClient()" shape="semi-round">{{(me.client.id !== client.id ? 'editclient' : 'edit') | translate}}</button>
          }
          @if (client.status === ClientStatus.ARCHIVED && couldArchive && !client.is_tenant_root) {
            <button nbButton size="small" (click)="setStatus(ClientStatus.ACTIVE)" shape="semi-round">{{'unarchiveclient' | translate}}</button>
          }
          @if (client.status === ClientStatus.ARCHIVED && couldArchive && !client.is_tenant_root && crmEnabled) {
            <button nbButton size="small" status="basic" (click)="setStatus(ClientStatus.PROSPECT)" shape="semi-round">{{'reopenasprospect' | translate}}</button>
          }
        </div>
      }
    </div>

    @if (!embedded) {
      @if (tabs.length > 1) {
        <nb-route-tabset [class.company-tabs]="onCompany" [tabs]="tabs" [fullWidth]="true"></nb-route-tabset>
      } @else {
        <router-outlet></router-outlet>
      }
    }

    @if (!isOnCvsRoute && !isOnCompanySettingsTab) {
    <article class="card-like card-flush profile-block">
      @if (client.status === ClientStatus.ARCHIVED) {
        <div class="pending">
          <nb-icon icon="alert-triangle-outline"></nb-icon>
          {{ 'clientarchived' | translate:{value: ((client.archived_at || client.updated_at) | date:'longDate')} }}
        </div>
      }
      @if (showTimeline && client.id && client.status !== ClientStatus.ARCHIVED) {
        <div class="timeline-container">
          <bst-timeline-chart [sidebar]="false" [tabletype]="TableType.Clients" [type]="type" [filter]="{for_Client_id: client.id}"></bst-timeline-chart>
        </div>
      }
      <div class="profile-grid">

        <!-- Contact card -->
        <section class="pcard">
          <h2><nb-icon icon="email-outline"></nb-icon><span>{{ 'contact' | translate }}</span></h2>
          <ul class="field-list">
            <li>
              <label><nb-icon icon="email-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.email' | translate" [attr.aria-description]="'explain.client.email' | translate">{{ 'email' | translate }}</span></label>
              @if (!editing && client.email) { <a [href]="'mailto:' + client.email" target="_blank">{{ client.email }}</a> }
              @if (editing) { <input nbInput type="email" fieldSize="small" [placeholder]="'enteritem' | translate:{value: ('email' | translate)}" formControlName="email"> }
            </li>
            <li>
              <label><nb-icon icon="phone-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.phone' | translate" [attr.aria-description]="'explain.client.phone' | translate">{{ 'phone' | translate }}</span></label>
              @if (!editing && client.phone) { <a [href]="'tel:' + client.phone" target="_blank">{{ Globals.formatPhone(client.phone) }}</a> }
              @if (editing) {
                <ngx-intl-tel-input [cssClass]="'size-small status-basic shape-rectangle'"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                  [searchCountryFlag]="true" [selectFirstCountry]="false"
                  [phoneValidation]="false" formControlName="phone">
                </ngx-intl-tel-input>
              }
            </li>
            <li>
              <label><nb-icon icon="home-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.address' | translate" [attr.aria-description]="'explain.client.address' | translate">{{ 'address' | translate }}</span></label>
              @if (!editing && client.address) { <a [href]="'https://maps.google.com/?q=' + client.address" target="_blank">{{ client.address }}</a> }
              @if (editing) { <bst-places-editor fullWidth size="small" [placeholder]="'enteritem' | translate:{value: ('address' | translate)}" formControlName="address"></bst-places-editor> }
            </li>
            <li>
              <label><nb-icon icon="link-2"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.url' | translate" [attr.aria-description]="'explain.client.url' | translate">{{ 'url' | translate }}</span></label>
              @if (!editing && client.url) { <a [href]="Globals.url(client.url)" target="_blank">{{ client.url }}</a> }
              @if (editing) { <input nbInput type="url" fieldSize="small" [placeholder]="'enteritem' | translate:{value: ('url' | translate)}" formControlName="url"> }
            </li>
            @if (!myclient) {
              <li>
                <label><nb-icon icon="globe-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.documentlanguage' | translate" [attr.aria-description]="'explain.client.documentlanguage' | translate">{{ 'documentlanguage' | translate }}</span></label>
                @if (!editing) { <span>{{ 'documentlanguages.' + (client.document_language || 'nl') | translate }}</span> }
                @if (editing) {
                  <nb-select size="small" formControlName="document_language">
                    <nb-option value="nl">{{ 'documentlanguages.nl' | translate }}</nb-option>
                    <nb-option value="en">{{ 'documentlanguages.en' | translate }}</nb-option>
                  </nb-select>
                }
              </li>
            }
          </ul>
        </section>

        <!-- About card -->
        <section class="pcard">
          <h2><nb-icon icon="info-outline"></nb-icon><span>{{ 'about' | translate }}</span></h2>
          <ul class="field-list">
            <li class="desc-row">
              <label><nb-icon icon="file-text-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.description' | translate" [attr.aria-description]="'explain.client.description' | translate">{{ 'description' | translate }}</span></label>
              @if (!editing) { <div class="prose-block">{{ client.description }}</div> }
              @if (editing) { <div><textarea nbInput fieldSize="small" maxlength="30000" [placeholder]="'enteritem' | translate:{value: ('description' | translate)}" formControlName="description" class="form-control input-full-width"></textarea></div> }
            </li>
            @if (myclient && (editing || client.matching_description)) {
              <li class="desc-row">
                <label><nb-icon icon="bulb-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.matchingdescription' | translate" [attr.aria-description]="'explain.client.matchingdescription' | translate">{{ 'matchingdescription' | translate }}</span></label>
                @if (!editing) { <div class="prose-block">{{ client.matching_description }}</div> }
                @if (editing) { <textarea nbInput fieldSize="small" maxlength="5000" [placeholder]="'enteritem' | translate:{value: ('matchingdescription' | translate)}" formControlName="matching_description" class="form-control input-full-width"></textarea> }
              </li>
            }
          </ul>
        </section>

        <!-- My company card (myclient only) -->
        @if (myclient) {
          <section class="pcard full-width">
            <h2><nb-icon icon="settings-outline"></nb-icon><span>{{ 'mycompany' | translate }}</span></h2>
            <ul class="field-list">
              @if (link) {
                <li>
                  <label><nb-icon icon="person-add-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.client.registerlink' | translate" [attr.aria-description]="'explain.client.registerlink' | translate">{{ 'registerlink' | translate }}</span></label>
                  <bst-copiable [link]="true" [text]="link"></bst-copiable>
                </li>
              }
              <li class="splash-row">
                <label><nb-icon icon="image-outline"></nb-icon><span>{{ 'splashimage' | translate }}</span></label>
                @if (editing) { <bst-photo-uploader [color]="'#edf1f7'" [value]="client.splash" [ratio]="null" [path]="'/clients/splash'" [data]="{id: client.id}" shape="semi-round"></bst-photo-uploader> }
                @if (!editing && client.splash) { <bst-photo-well [color]="'#edf1f7'" shape="rectangle" [file]="client.splash"></bst-photo-well> }
                @if (!editing && !client.splash) { <span class="no-splash">{{ 'nosplashimage' | translate }}</span> }
              </li>
            </ul>
          </section>
        }

        @if (canSeeReimbursementRates && !onCompany) {
          <section class="pcard full-width">
            <h2><nb-icon icon="car-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'reimbursementrate.hint' | translate" [attr.aria-description]="'reimbursementrate.hint' | translate">{{ 'reimbursementrate.title' | translate }}</span></h2>
            <bst-reimbursement-rates></bst-reimbursement-rates>
          </section>
        }

        @if (canSeeInvoicing && myclient && !onCompany) {
          <section class="pcard full-width">
            <h2><nb-icon icon="credit-card-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.company.hint' | translate" [attr.aria-description]="'invoicing.company.hint' | translate">{{ 'invoicing.company.title' | translate }}</span></h2>
            <bst-invoicing-company></bst-invoicing-company>
          </section>
          <section class="pcard full-width">
            <h2><nb-icon icon="percent-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.vat.hint' | translate" [attr.aria-description]="'invoicing.vat.hint' | translate">{{ 'invoicing.vat.title' | translate }}</span></h2>
            <bst-vat-options></bst-vat-options>
          </section>
          <section class="pcard full-width">
            <h2><nb-icon icon="car-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.km.hint' | translate" [attr.aria-description]="'invoicing.km.hint' | translate">{{ 'invoicing.km.title' | translate }}</span></h2>
            <bst-km-cost-type></bst-km-cost-type>
          </section>
        }

        @if (canSeeIntake && myclient) {
          <section class="pcard full-width">
            <h2><nb-icon icon="email-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'intake.address.intro' | translate" [attr.aria-description]="'intake.address.intro' | translate">{{ 'intake.address.title' | translate }}</span></h2>
            <bst-intake-address-block mode="company"></bst-intake-address-block>
          </section>
        }

        @if (canSeeInvoicing && !myclient && client.id) {
          <section class="pcard full-width">
            <h2><nb-icon icon="credit-card-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.client.hint' | translate" [attr.aria-description]="'invoicing.client.hint' | translate">{{ 'invoicing.client.title' | translate }}</span></h2>
            <bst-invoicing-client [clientId]="client.id" [focusField]="focusField"></bst-invoicing-client>
          </section>
        }

      </div>
    </article>
    }

    <bst-client-organization-section *ngIf="client" [client]="client" (merged)="reload()"></bst-client-organization-section>

    @if (showCrmPanel && client.id && !isOnCvsRoute) {
      <bst-client-crm-section #crm [clientId]="client.id"></bst-client-crm-section>
    }
</ng-container>
}
